import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a6396d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-min-h-[50px] tw-justify-center tw-items-center tw-gap-[15px]" }
const _hoisted_2 = { class: "tw-flex tw-flex-col" }
const _hoisted_3 = { class: "member-topic-title" }
const _hoisted_4 = { class: "member-topic-sub-description" }
const _hoisted_5 = { class: "member-topic-role tw-ml-[10px]" }

import { routers } from "@/utils/constants";
import EventEmitter from "@/utils/eventEmitter";

/** components */
import IconRight from "@/components/common/globalSearch/menuSearch/iconChevronRight.vue";
import GlobalAvatar from "@/components/common/globalAvatar.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'memberTopic',
  props: {
    data: {}
  },
  emits: ["close-menu"],
  setup(__props: any, { emit }) {

const props = __props;





const onSelect = () => {
  emit("close-menu");
  setTimeout(() => {
    EventEmitter.emit("member-management-open-profile-modal", props.data);
  }, 500);
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: _unref(routers).settingTeamMembers,
    class: "tw-flex tw-w-full tw-items-center tw-justify-between tw-cursor-pointer !tw-no-underline",
    onClick: _withModifiers(onSelect, ["stop"])
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!_ctx.data?.avatar?.avatarImageFileId)
          ? (_openBlock(), _createBlock(GlobalAvatar, {
              key: 0,
              name: _ctx.data?.fullName || _ctx.data?.email
            }, null, 8, ["name"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(`${_ctx.data?.firstName} ${_ctx.data?.lastName}`), 1),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.data?.org.orgNameShort), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", null, _toDisplayString(_ctx.data?.roles?.[0].roleName), 1)
        ])
      ]),
      _createVNode(IconRight)
    ]),
    _: 1
  }, 8, ["to", "onClick"]))
}
}

})